import { render, staticRenderFns } from "./WorkLoadType.vue?vue&type=template&id=0a1954a2"
import script from "./WorkLoadType.vue?vue&type=script&lang=js"
export * from "./WorkLoadType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a1954a2')) {
      api.createRecord('0a1954a2', component.options)
    } else {
      api.reload('0a1954a2', component.options)
    }
    module.hot.accept("./WorkLoadType.vue?vue&type=template&id=0a1954a2", function () {
      api.rerender('0a1954a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/WorkLoadType.vue"
export default component.exports